var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInovacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.840 103.950",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 112.79 6.101 L 112.79 77.73 C 112.79 81.08 110.049 83.83 106.689 83.83 L 6.1 83.83 C 2.75 83.83 0 81.09 0 77.73 L 0 6.101 C 0 2.751 2.74 0 6.1 0 L 106.689 0 C 110.039 0 112.79 2.751 112.79 6.101 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 112.79 6.101 L 112.79 77.73 C 112.79 81.08 110.049 83.83 106.689 83.83 L 6.1 83.83 C 2.75 83.83 0 81.09 0 77.73 L 0 6.101 C 0 2.751 2.74 0 6.1 0 L 106.689 0 C 110.039 0 112.79 2.751 112.79 6.101 Z",
    fill: "rgb(90,170,160)",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 112.79 0 L 112.79 9.141 C 112.79 12.491 110.049 15.24 106.689 15.24 L 6.1 15.24 C 2.75 15.24 0 12.501 0 9.141 L 0 0 L 112.79 0 Z",
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 68.590)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.05 0 C 1.37 0 0 1.36 0 3.05 C 0 4.73 1.36 6.1 3.05 6.1 C 4.73 6.1 6.101 4.74 6.101 3.05 C 6.091 1.36 4.73 0 3.05 0 Z",
    fill: "rgb(90,170,160)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 53.350 73.160)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 48.771 9.46 L 0 9.46 C 0 4.24 3.41 0 7.62 0 L 41.15 0 C 45.36 0 48.771 4.24 48.771 9.46 Z",
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 32.010 94.490)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.29 0 L 0 0 L 0 10.67 L 18.29 10.67 L 18.29 0 Z",
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 47.250 83.830)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.29 0 L 0 0 L 0 10.67 L 18.29 10.67 L 18.29 0 Z",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 47.250 83.830)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.3 48 L 7.7 48 C 3.45 48 0 44.55 0 40.3 L 0 7.7 C 0 3.45 3.45 0 7.7 0 L 40.3 0 C 44.55 0 48 3.45 48 7.7 L 48 40.3 C 48 44.55 44.55 48 40.3 48 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 79.840 7.950)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.601 8.164 L 3.182 7.35 L 3.181 7.35 L 2.601 8.164 Z M 13 1.664 C 13.707 0.957 13.707 0.956 13.706 0.956 C 13.706 0.956 13.706 0.955 13.705 0.955 C 13.705 0.954 13.704 0.954 13.703 0.953 C 13.702 0.951 13.7 0.95 13.698 0.948 C 13.695 0.944 13.69 0.94 13.685 0.935 C 13.675 0.926 13.663 0.914 13.647 0.9 C 13.617 0.871 13.575 0.834 13.523 0.79 C 13.419 0.702 13.271 0.586 13.079 0.454 C 12.696 0.191 12.137 -0.134 11.401 -0.41 C 9.919 -0.966 7.762 -1.307 4.958 -0.606 L 5.2 0.364 L 5.443 1.334 C 7.839 0.735 9.582 1.044 10.699 1.463 C 11.263 1.674 11.679 1.918 11.946 2.102 C 12.079 2.194 12.175 2.27 12.233 2.319 C 12.262 2.343 12.282 2.361 12.292 2.37 C 12.297 2.375 12.299 2.377 12.3 2.377 C 12.3 2.378 12.299 2.377 12.298 2.376 C 12.297 2.375 12.297 2.375 12.296 2.374 C 12.295 2.373 12.295 2.373 12.295 2.373 C 12.294 2.372 12.294 2.372 12.294 2.372 C 12.293 2.371 12.293 2.371 13 1.664 Z M 5.2 0.364 L 4.958 -0.606 C 2.04 0.123 0.458 1.914 0.079 3.933 C -0.285 5.869 0.499 7.894 2.02 8.978 L 2.601 8.164 L 3.181 7.35 C 2.332 6.744 1.816 5.518 2.044 4.302 C 2.257 3.169 3.16 1.905 5.443 1.334 L 5.2 0.364 Z M 2.601 8.164 L 2.019 8.978 C 3.237 9.847 4.609 10.529 5.908 11.133 C 7.24 11.751 8.458 12.272 9.514 12.858 C 10.569 13.444 11.313 14.02 11.739 14.662 C 12.129 15.251 12.304 15.976 12.04 17.032 L 13.011 17.274 L 13.981 17.516 C 14.367 15.967 14.135 14.657 13.406 13.557 C 12.712 12.51 11.627 11.744 10.485 11.11 C 9.345 10.476 8.001 9.899 6.751 9.319 C 5.469 8.724 4.239 8.106 3.182 7.35 L 2.601 8.164 Z M 13.011 17.274 L 12.04 17.032 C 11.77 18.116 11.255 18.792 10.603 19.232 C 9.926 19.689 9.022 19.944 7.906 20.017 C 5.646 20.167 2.866 19.558 0.242 18.904 L 0 19.874 L -0.242 20.844 C 2.344 21.489 5.419 22.186 8.038 22.013 C 9.36 21.926 10.65 21.613 11.721 20.89 C 12.817 20.151 13.601 19.038 13.981 17.516 L 13.011 17.274 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 96.859 14.240) matrix(1 0 0 1 0 5.416)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 5.8 L 1 5.8 L 1 0 L 0 0 L -1 0 L -1 5.8 L 0 5.8 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 96.859 14.240) matrix(1 0 0 1 7.410 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 5.79 L 1 5.79 L 1 0 L 0 0 L -1 0 L -1 5.79 L 0 5.79 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 96.859 14.240) matrix(1 0 0 1 7.410 26.479)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 1 L 48 1 L 48 0 L 48 -1 L 0 -1 L 0 0 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 15.840 31.950)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 1 L 44.4 1 L 44.4 0 L 44.4 -1 L 0 -1 L 0 0 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 15.840 39.950)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 1 L 38.4 1 L 38.4 0 L 38.4 -1 L 0 -1 L 0 0 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 15.840 47.950)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInovacao);
export default __webpack_public_path__ + "static/media/inovacao.f8a55550b023befc55057f10a43e23e1.svg";
export { ForwardRef as ReactComponent };